<template>
    <div v-if="!store.loading && !filteredSchedules.length" class="flex h-24 items-center justify-center text-sm text-gray">
        Ничего не найдено
    </div>
    <div v-else class="flex bg-white" v-for="(schedule, index) in filteredSchedules">
        <div class="ds-schedule-employee-cell">
            <Employee :avatar="schedule.user?.avatar" :first-name="schedule.user.first_name" :last-name="schedule.user.last_name"
                :middle-name="schedule.user.middle_name"
                :position="schedule.position?.name" :id="schedule.id" />
        </div>

        <div class="flex flex-1">
            <TimeSheetItem v-for="day in days" :key="day" :schedule :day
                :class="{ 'bg-grayxlight': index % 2 === 0 && !store.isLightTheme, 'border-r': day === +today && store.currentScheduleDate.format('MM') === dayjs().format('MM') }"
                @click="emit('day-clicked', { day, index: store.schedules.indexOf(schedule), cell: $event.currentTarget })" />
        </div>
    </div>
</template>

<script setup lang="ts">
import type { Schedule } from '@/types'

interface Props {
    days: number,
    today: string,
    schedules: Schedule[]
}

import { computed, onMounted } from 'vue'
import TimeSheetItem from './TimeSheetItem.vue'
import Employee from '../timesheet/Employee.vue'
import dayjs from 'dayjs'
import { useScheduleStore } from '@/stores/scheduleStore'

const store = useScheduleStore()
const { days, today, schedules } = defineProps<Props>()
const emit = defineEmits(['day-clicked'])

const filteredSchedules = computed(() => schedules.filter(item => !item.is_outsource && !item.is_vacancy))

onMounted(async () => {
    await store.fetchTimeSheet()
 })
</script>
